module.exports = __webpack_public_path__ + "officialStatic/img/logo20.094e560.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo20.png
// module id = oDdh
// module chunks = 0